// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const Phone_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'm20.847 14.856-4.416-1.98-.013-.005a1.5 1.5 0 0 0-1.422.131l-.07.053L12.644 15c-1.446-.702-2.938-2.183-3.64-3.61l1.948-2.317q.028-.035.053-.072a1.5 1.5 0 0 0 .124-1.412v-.011L9.144 3.154a1.5 1.5 0 0 0-1.558-.893A5.274 5.274 0 0 0 3 7.5C3 14.944 9.056 21 16.5 21a5.274 5.274 0 0 0 5.239-4.586 1.5 1.5 0 0 0-.892-1.558ZM16.5 19.5a12.013 12.013 0 0 1-12-12 3.77 3.77 0 0 1 3.27-3.75v.011l1.968 4.406-1.938 2.32-.053.072a1.5 1.5 0 0 0-.094 1.472c.85 1.737 2.6 3.474 4.355 4.323a1.5 1.5 0 0 0 1.477-.107l.07-.053 2.278-1.944 4.407 1.973h.01A3.77 3.77 0 0 1 16.5 19.5Z',
  viewBox: '0 0 24 24',
  glyph: 'Phone_Stroke2_Corner0_Rounded',
})

export const PhoneHaptic_Stroke2_Corner2_Rounded = createSinglePathSVG({
  path: 'M16.5 1.5h-9a2.25 2.25 0 0 0-2.25 2.25v16.5A2.25 2.25 0 0 0 7.5 22.5h9a2.25 2.25 0 0 0 2.25-2.25V3.75A2.25 2.25 0 0 0 16.5 1.5Zm.75 18.75a.75.75 0 0 1-.75.75h-9a.75.75 0 0 1-.75-.75V3.75A.75.75 0 0 1 7.5 3h9a.75.75 0 0 1 .75.75Zm-1.5-15A.75.75 0 0 1 15 6H9a.75.75 0 0 1 0-1.5h6a.75.75 0 0 1 .75.75Z',
  viewBox: '0 0 24 24',
  glyph: 'PhoneHaptic_Stroke2_Corner2_Rounded',
})
